import { page, queryEntityLog, queryEntityStateLog } from '@/services/common/Log';
import {
  queryEntityLogSection
} from '@/services/wcs/OperationPoint';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'log',

  state: {
    data: {
      list: [],
      pagination: {},
    },
    labelData: {
      list: [],
      pagination: {}
    }
  },
  effects: {
    *queryEntityLog({ payload, callback }, { call, put }) {
      // 基本资料页面的作业点下的区段添加绑定拣货员的操作日志
      const service = payload.ipsArchive ? queryEntityLogSection : queryEntityLog;
      const response = yield call(service, payload);

      if (response && response.success) {
        yield put({
          type: 'save',
          entityUuid: payload.searchKeyValues.entityUuid,
          payload: {
            list: response.data.records,
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      } else {
        yield put({
          type: 'save',
          entityUuid: payload.searchKeyValues.entityUuid,
          payload: {
            list: [],
            pagination: {},
          },
        });
      }
      if (callback) callback(response);
    },
    *page({ payload, callback }, { call, put }) {
      const response = yield call(page, payload);
      if (response && response.success) {
        yield put({
          type: 'saveLableLog',
          payload: {
            list: response.data.records,
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      // if (callback) callback(response);
    },
    *queryEntityStateLog({ payload, callback }, { call, put }) {
      const response = yield call(queryEntityStateLog, payload);
      if (callback) callback(response);
    }
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
        entityUuid: action.entityUuid,
      };
    },
    saveLableLog(state, action) {
      return {
        ...state,
        labelData: action.payload,
      };
    }
  },
}
